export default __webpack_public_path__ + "static/media/ArrowIcon.8c31f575.png";